import React from 'react';
import PropTypes from 'prop-types';
import css from '@src/js/Style';
import View from '../Designer/View';
import Text from '../Designer/Text';
import Translation from '../Base/Translation';
import OfferCard from './OfferCard';
import Slider from '../Base/Slider';
import AdaptiveTrait from '../../AdaptiveTrait';

export default class MonthlyOffers extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            offers: null,
        };

        new AdaptiveTrait(this);
    }

    static get propTypes() {

        return {
            templateId: PropTypes.string,
        };
    }

    componentDidMount() {

        fetch(`/api/v2/catalog/offers.json?templateId=${this.props.templateId}`)
            .then((response) => response.json())
            .then((response) => this.setState({ offers: response.context }));
    }

    renderDesktop() {

        if (!this.state.offers)
            return null;

        return (
            <View className='flex flex-wrap gap-xl my-12'>
                <Text className='w-full title3 text-center'><Translation tag='aggregation.top.title' /></Text>
                <View className='w-full flex gap items-stretch'>
                    <Slider count={ 0 }>
                        { this.state.offers.map((offer) => this.renderOffer(offer)) }
                    </Slider>
                </View>
            </View>
        );
    }

    renderMobile() {
        
        if (!this.state.offers)
            return null;

        return (
            <View className='flex flex-wrap gap-lg my-12 mobile:-mx-4'>
                <Text className='w-full title3 text-center'><Translation tag='aggregation.top.title' /></Text>
                <View className='w-full flex gap items-stretch'>
                    <Slider className={ css('flex w-full flex-wrap overflow-x-clip mobile:px-4') } count={ 1.25 } withoutGap={ true }>
                        { this.state.offers.map((offer) => this.renderOffer(offer)) }
                    </Slider>
                </View>
            </View>
        );
    }

    renderOffer(offer) {

        return (
            <OfferCard
                key={ offer.id }
                title={ offer.title }
                mainImageLink={ offer.imageUri }
                mainImageAlt={ offer.title }
                logoImageLink={ offer.company.smallLogoUri }
                logoImageAlt={ offer.company.name }
                promoText={ offer.promoText }
                buttonText={ offer.button.anchor }
                buttonLink={ offer.button.link }
                buttonSubText={ offer.button.subText }
                hasBorder={ offer.hasBorder }
            />
        );

    }
    
}